<script>
    export let isActive;
</script>

<style type="text/scss">
  * {
    transition: 250ms;
  }

  .inactive {
    margin: 16px;
    cursor: pointer;

    circle:nth-child(2) {
      fill: var(--white);
      stroke: var(--sapphire);
      r: 19;
    }

    path {
      fill: var(--sapphire);
    }

    &:hover {
      circle:nth-child(2) {
        fill: var(--yellow);
        stroke: var(--sapphire);
        r: 23;
      }
    }

    &:active {
      circle:nth-child(2) {
        fill: var(--sapphire);
        stroke: var(--sapphire);
        r: 23;
      }

      path {
        fill: var(--yellow);
      }
    }
  }
</style>

{#if isActive }
    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_d)">
            <circle cx="40" cy="38" r="28" fill="#FFD436"/>
        </g>
        <path d="M36.0001 36.6667C37.0549 36.6667 38.0861 36.3539 38.9631 35.7678C39.8402 35.1818 40.5238 34.3489 40.9274 33.3743C41.3311 32.3998 41.4367 31.3274 41.2309 30.2929C41.0251 29.2583 40.5172 28.308 39.7713 27.5621C39.0254 26.8162 38.0751 26.3083 37.0406 26.1025C36.006 25.8967 34.9336 26.0023 33.9591 26.406C32.9846 26.8096 32.1516 27.4932 31.5656 28.3703C30.9795 29.2474 30.6667 30.2785 30.6667 31.3333C30.6667 32.7478 31.2287 34.1044 32.2288 35.1046C33.229 36.1048 34.5856 36.6667 36.0001 36.6667ZM46.6667 39.3333C47.4579 39.3333 48.2312 39.0987 48.889 38.6592C49.5468 38.2197 50.0595 37.595 50.3623 36.8641C50.665 36.1332 50.7442 35.3289 50.5899 34.553C50.4355 33.7771 50.0546 33.0643 49.4952 32.5049C48.9358 31.9455 48.223 31.5645 47.4471 31.4102C46.6712 31.2559 45.8669 31.3351 45.136 31.6378C44.4051 31.9406 43.7804 32.4533 43.3409 33.1111C42.9013 33.7689 42.6667 34.5422 42.6667 35.3333C42.6667 36.3942 43.0882 37.4116 43.8383 38.1618C44.5885 38.9119 45.6059 39.3333 46.6667 39.3333ZM52.0001 48.6667C52.3537 48.6667 52.6928 48.5262 52.9429 48.2761C53.1929 48.0261 53.3334 47.687 53.3334 47.3333C53.3323 46.0872 52.982 44.8663 52.3222 43.8092C51.6624 42.752 50.7195 41.901 49.6005 41.3526C48.4816 40.8042 47.2313 40.5805 45.9915 40.7067C44.7518 40.8329 43.5723 41.304 42.5867 42.0667C41.2808 40.7658 39.6188 39.8808 37.8105 39.5232C36.0022 39.1657 34.1285 39.3516 32.4257 40.0575C30.7229 40.7634 29.2673 41.9578 28.2424 43.4899C27.2175 45.022 26.6692 46.8233 26.6667 48.6667C26.6667 49.0203 26.8072 49.3594 27.0573 49.6095C27.3073 49.8595 27.6465 50 28.0001 50H44.0001C44.3537 50 44.6928 49.8595 44.9429 49.6095C45.1929 49.3594 45.3334 49.0203 45.3334 48.6667"
              fill="#082567"/>
        <defs>
            <filter id="filter0_d" x="0" y="0" width="80" height="80" filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
                <feOffset dy="2"/>
                <feGaussianBlur stdDeviation="6"/>
                <feColorMatrix type="matrix" values="0 0 0 0 0.95 0 0 0 0 0.773017 0 0 0 0 0.122708 0 0 0 0.4 0"/>
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
            </filter>
        </defs>
    </svg>

{:else }
    <svg class="inactive" width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="24" cy="24" r="24" fill="white"/>
        <circle cx="24" cy="24" r="19" fill="white" stroke="#082567" stroke-width="2"/>
        <path d="M21 23C21.7911 23 22.5645 22.7654 23.2223 22.3259C23.8801 21.8864 24.3928 21.2616 24.6955 20.5307C24.9983 19.7998 25.0775 18.9956 24.9231 18.2196C24.7688 17.4437 24.3878 16.731 23.8284 16.1716C23.269 15.6122 22.5563 15.2312 21.7804 15.0769C21.0044 14.9225 20.2002 15.0017 19.4693 15.3045C18.7384 15.6072 18.1136 16.1199 17.6741 16.7777C17.2346 17.4355 17 18.2089 17 19C17 20.0609 17.4214 21.0783 18.1716 21.8284C18.9217 22.5786 19.9391 23 21 23ZM29 25C29.5933 25 30.1734 24.8241 30.6667 24.4944C31.1601 24.1648 31.5446 23.6962 31.7716 23.1481C31.9987 22.5999 32.0581 21.9967 31.9424 21.4147C31.8266 20.8328 31.5409 20.2982 31.1213 19.8787C30.7018 19.4591 30.1672 19.1734 29.5853 19.0576C29.0033 18.9419 28.4001 19.0013 27.8519 19.2284C27.3038 19.4554 26.8352 19.8399 26.5056 20.3333C26.1759 20.8266 26 21.4067 26 22C26 22.7957 26.3161 23.5587 26.8787 24.1213C27.4413 24.6839 28.2044 25 29 25ZM33 32C33.2652 32 33.5196 31.8946 33.7071 31.7071C33.8946 31.5196 34 31.2652 34 31C33.9992 30.0654 33.7365 29.1497 33.2416 28.3569C32.7468 27.564 32.0396 26.9258 31.2003 26.5145C30.3611 26.1032 29.4234 25.9353 28.4936 26.03C27.5638 26.1247 26.6791 26.478 25.94 27.05C24.9605 26.0744 23.7141 25.4106 22.3578 25.1424C21.0016 24.8743 19.5963 25.0137 18.3192 25.5431C17.0421 26.0726 15.9504 26.9683 15.1817 28.1174C14.4131 29.2665 14.0019 30.6175 14 32C14 32.2652 14.1054 32.5196 14.2929 32.7071C14.4804 32.8946 14.7348 33 15 33H27C27.2652 33 27.5196 32.8946 27.7071 32.7071C27.8946 32.5196 28 32.2652 28 32"
              fill="#082567"/>
    </svg>

{/if}
